<div class="table-responsive">
  <mat-form-field *ngIf="superAdmin">
    <mat-label>Tenant filtern</mat-label>
    <mat-select (selectionChange)="applyFilter($event.value)">
      <mat-option *ngFor="let tenant of tenantFilterValues" [value]="tenant">{{ tenant }}</mat-option>
    </mat-select>
  </mat-form-field>
<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef>Vorname</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.firstName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <mat-header-cell *matHeaderCellDef>Nachname</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.lastName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="street">
    <mat-header-cell *matHeaderCellDef>Straße</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.street }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="houseNumber">
    <mat-header-cell *matHeaderCellDef>Hausnummer</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.houseNumber }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="zip">
    <mat-header-cell *matHeaderCellDef>PLZ</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.zip }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="city">
    <mat-header-cell *matHeaderCellDef>Stadt</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.city }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="country">
    <mat-header-cell *matHeaderCellDef>Land</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.country }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="mobileNumber">
    <mat-header-cell *matHeaderCellDef>Telefonnummer</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.mobileNumber }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef>E-Mail</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.email }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <mat-header-cell *matHeaderCellDef>Erstellt von</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.createdBy }}</mat-cell>
  </ng-container>

  <!--<ng-container matColumnDef="activeShift">
    <mat-header-cell *matHeaderCellDef>Aktive Schicht</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.activeShift | yesNo }}</mat-cell>
  </ng-container> -->

  <ng-container matColumnDef="tenantName" *ngIf="superAdmin">
    <mat-header-cell *matHeaderCellDef>Tenant</mat-header-cell>
    <mat-cell *matCellDef="let waiter">{{ waiter.tenantName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="activeShift">
    <mat-header-cell *matHeaderCellDef>Aktive Schicht</mat-header-cell>
    <mat-cell *matCellDef="let waiter">
      <ng-container *ngIf="waiter.activeShift; else plainText">
        <a (click)="showLoginCode(waiter)" style="cursor: pointer; text-decoration: underline;">
          {{ waiter.activeShift | yesNo }}
        </a>
      </ng-container>
      <ng-template #plainText>
        {{ waiter.activeShift | yesNo }}
      </ng-template>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="details">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let waiter">
      <button mat-icon-button (click)="showWaiterDetails(waiter)">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="delete">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let waiter">
      <button mat-icon-button (click)="deleteWaiter(waiter)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</table>
</div>
